var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChecboxFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckBoxFilled"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 132",
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#0B0C0D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
    fill: "#FF9C25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecboxFilled);
export default __webpack_public_path__ + "static/media/icon-checbox-filled.04d4776fddf2430d8c77377399aa235e.svg";
export { ForwardRef as ReactComponent };